import { MoneyFormatter, NSSpace, NSSpaceSizeType, StringFormatter } from 'namirasoft-site-react';
import Styles from './NSPOfferItemCardPriceTable.module.css';

export interface NSPOfferItemCardPriceTableProps
{
	volume_or_graduated: boolean;
	amounts: { first_unit: number, last_unit: number, per_unit: number, flat_fee: number }[];
	currency: string;
	was?: string | null;
	per?: string;
	subtitle?: string;
	description?: string;
}

export function NSPOfferItemCardPriceTable(props: NSPOfferItemCardPriceTableProps)
{
	return (
		<>
			{
				props.was &&
				<div className={Styles.nsp_offer_item_card_price_table_was_parent}>
					<div className={Styles.nsp_offer_item_card_price_table_was}>
						<h2>
							{props.was}
							<span className={Styles.nsp_offer_item_card_price_table_was_diameter}></span>
						</h2>
					</div>
				</div>
			}
			<NSSpace size={NSSpaceSizeType.MINI} />
			{
				<div className={Styles.nsp_offer_card_header}>
					<h5>{props.volume_or_graduated ? "By Volume" : "Graduated"}:</h5>
					<NSSpace size={NSSpaceSizeType.MICRO} />
					<p>{props.volume_or_graduated ? "All units price based on final tier reached!" : "Tiers apply progressively as quantity increase."}</p>
				</div>
			}
			<div className='d-flex flex-row justify-content-center align-items-center gap-3'>
				<table className={Styles.nsp_offer_item_card_price_table_table}>
					<tr>
						<th>First</th>
						<th>Last</th>
						<th>Per</th>
						<th>Flat Fee</th>
					</tr>
					{
						(props.amounts ?? []).map((amount, index) => <tr>
							<td>{amount.first_unit}</td>
							<td>{index === props.amounts.length - 1 ? "∞" : amount.last_unit}</td>
							<td>{new MoneyFormatter(undefined, props.currency, 0, 5).format(amount.per_unit)}</td>
							<td>{new MoneyFormatter(undefined, props.currency, 0, 5).format(amount.flat_fee)}</td>
						</tr>)
					}
				</table>
			</div>
			{
				<div
					className={Styles.nsp_offer_item_card_price_table_per}
				>
					{
						props.per &&
						<span>{StringFormatter.toHTML(props.per)}</span>
					}
				</div>
			}
			{
				props.subtitle &&
				<div
					className={Styles.nsp_offer_item_card_price_table_subtitle}
				>
					<p>{props.subtitle}</p>
				</div>
			}
			{
				props.description &&
				<div
					className={Styles.nsp_offer_item_card_price_table_subtitle}
				>
					<p>{props.description}</p>
				</div>
			}
		</>
	);
}